import { asyncType } from "redux/types/asyncTypes";

export const FETCH_ADV_CAMPAIGNS = asyncType("FETCH_CAMPAIGNS");
export const JOIN_CAMPAIGN = asyncType("JOIN_CAMPAIGN");
